import * as React from 'react'
import {
  EarnPointsSectionContainer,
  EarnPointsSectionRow,
  EarnPointsSectionRowMobile,
  QuizCard,
  QuizBigCardImage,
  EarnPointsSectionHeader,
  EarnPointsTitle,
  EarnPointsSubtitle,
  EarnPointsBottomTitle,
  EarnPointsBottomSubtitle,
  EarnPointsSectionButtonWrapper,
  StyledButton,
  SpinnerWrapper,
  CardTitle,
  EmptyCol,
  Blur,
  QuizSmallCardImage,
  SmallCardTitle,
  SmallBlur,
  SmallEmptyCol,
  ItalicCardTitle,
  Badge,
  BigCardTitle,
  QuizCardMobile,
  BigCardTitleItalic
} from './EarnPointsSection.elements'

/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import {Spinner} from "@components/Spinner";
import {compileAnalyticsEventProps} from "@lib/analytics-event-props";
import Analytics from "@lib/Analytics";
import {MouseEvent} from "react";

export type EarnPointsSectionProps = {
  quizzes: any
  title?: string
  subtitle?: string
  bottomTitle?: string
  bottomSubtitle?: string
}

export const EarnPointsSection: React.FunctionComponent<EarnPointsSectionProps> = ({ quizzes, title, subtitle, bottomTitle, bottomSubtitle }) => {
  const hasError = quizzes?.message === 'error' || quizzes === []
  const cards = quizzes?.topics && quizzes?.topics.slice(0,10)
  const bigCard1 = cards && cards[0];
  const bigCard2 = cards && cards[1];
  const bigCard3 = cards && cards[2];
  const firstRowCards = cards && cards.slice(2,6)
  const secondRowCards = cards && cards.slice(6,10)

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    Analytics.log('Click', compileAnalyticsEventProps({ location: 'earn-points-section' }))

    setTimeout(() => {
      window.location.href = '/signup'
    }, 500)
  }

  return (
    <EarnPointsSectionContainer>
      <EarnPointsSectionHeader>
        <EarnPointsTitle>
          {title}
        </EarnPointsTitle>
      </EarnPointsSectionHeader>
      <EarnPointsSubtitle>
        {subtitle}
      </EarnPointsSubtitle>
      {
        bigCard1 ? (
          <>
            <EarnPointsSectionRow>
              <QuizCard>
                <BigCardTitle>Today’s Quiz</BigCardTitle>
                <QuizBigCardImage imageUrl={bigCard1.image}>
                  <Blur>
                    <CardTitle>{bigCard1.name}</CardTitle>
                  </Blur>
                  <Badge imageUrl={'https://media.healthiq.com/homepage/membership/3X-blue-banner.svg'}/>
                </QuizBigCardImage>
              </QuizCard>
              <EmptyCol />
              <QuizCard>
                <BigCardTitle>This Weeks Quizzes</BigCardTitle>
                <QuizBigCardImage imageUrl={bigCard2.image}>
                  <Blur>
                    <CardTitle>{bigCard2.name}</CardTitle>
                  </Blur>
                  <Badge imageUrl={'https://media.healthiq.com/homepage/membership/2X-white-banner.svg'}/>
                </QuizBigCardImage>
              </QuizCard>
              <QuizCardMobile>
                <BigCardTitleItalic>Plus, over 2000 more!</BigCardTitleItalic>
                <QuizBigCardImage imageUrl={bigCard3.image}>
                  <Blur>
                    <CardTitle>{bigCard3.name}</CardTitle>
                  </Blur>
                </QuizBigCardImage>
              </QuizCardMobile>
            </EarnPointsSectionRow>
            <EarnPointsSectionRowMobile>
              {
                firstRowCards && firstRowCards.map((card, idx) => {
                  return (
                    <React.Fragment key={card.name}>
                      <QuizCard>
                        <QuizSmallCardImage imageUrl={card.image}>
                          <SmallBlur>
                            <SmallCardTitle>{card.name}</SmallCardTitle>
                          </SmallBlur>
                        </QuizSmallCardImage>
                      </QuizCard>
                      <>
                        { idx < 3 &&
                          <SmallEmptyCol />
                        }
                      </>
                    </React.Fragment>
                  )
                })
              }
            </EarnPointsSectionRowMobile>
            <EarnPointsSectionRowMobile>
              {
                secondRowCards && secondRowCards.map((card, idx) => {
                  return (
                    <React.Fragment key={card.name}>
                      { idx < 3 &&
                        <>
                          <QuizCard>
                            <QuizSmallCardImage imageUrl={card.image}>
                              <SmallBlur>
                                <SmallCardTitle>{card.name}</SmallCardTitle>
                              </SmallBlur>
                            </QuizSmallCardImage>
                          </QuizCard>
                          <SmallEmptyCol />
                        </>
                      }
                      { idx === 3 &&
                      <>
                        <QuizCard>
                          <QuizSmallCardImage imageUrl={'https://media.healthiq.com/homepage/membership/Stationary-Bike-About-Page.jpg'}>
                              <ItalicCardTitle>Plus, over<br/>2,000 more!</ItalicCardTitle>
                          </QuizSmallCardImage>
                        </QuizCard>
                      </>
                      }
                    </React.Fragment>
                  )
                })
              }
            </EarnPointsSectionRowMobile>
          </>
        ) : (
          <>
            { !hasError &&
              <SpinnerWrapper>
                <Spinner />
              </SpinnerWrapper>
            }
          </>
        )
      }
      <EarnPointsBottomTitle>
        {bottomTitle}
      </EarnPointsBottomTitle>
      <EarnPointsBottomSubtitle>
        {bottomSubtitle}
      </EarnPointsBottomSubtitle>
      <EarnPointsSectionRow>
        <EarnPointsSectionButtonWrapper>
          <StyledButton
            onClick={handleClick}
            variant="white-blue-text"
            type="submit"
          >
            TAKE QUIZ NOW
          </StyledButton>
        </EarnPointsSectionButtonWrapper>
      </EarnPointsSectionRow>

    </EarnPointsSectionContainer>
  )
}